import { Flex } from "@chakra-ui/react";

const Footer = () => {
  return (
    <Flex
      color="white"
      fontWeight="bold"
      justify="center"
      bg="headline.400"
      minH="50px"
      align="center"
    >
      Created by Ben Zentek
    </Flex>
  );
};
export default Footer;
